import { useTranslations } from '@npco/common-utils-translations'
import {
  BoatSinking,
  Box,
  Flex,
  Message,
  MessageSize,
} from '@npco/zeller-design-system'

import { useIsMobileResolution } from 'hooks/useIsMobileResolution'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { TransferEvent } from 'pages/Transfer/Transfer.stateMachine'
import { translations } from 'pages/Transfer/TransferFields/MFATransfer/MFATransfer.i18n'

export const MFAError = () => {
  const {
    transferState: [, send],
  } = useTransferState()
  const isMobile = useIsMobileResolution()
  const t = useTranslations(translations)

  const iconSize = isMobile ? 'medium' : 'large'

  return (
    <Flex width="100%" pt="10%" justifyContent="center">
      <Message
        align="center"
        title={t('mfaErrorTitle')}
        description={
          <Box textAlign="center">
            <Box>{t('mfaErrorDescription1')}</Box>
            <Box>{t('mfaErrorDescription2')}</Box>
          </Box>
        }
        size={MessageSize.MEDIUM}
        secondaryButton={{
          label: t('mfaErrorSecondaryButtonLabel'),
          onClick: () => send(TransferEvent.Back),
        }}
        image={<BoatSinking size={iconSize} />}
      />
    </Flex>
  )
}
